import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { CTAButton } from '../ui'

const AboutOptimization = ({ openContactModal }) => {
  return (
    <section className='bg-[#f8f8f8]/[0.83] rounded-[25px] px-3 py-6 sm:px-5 md:py-10 md:px-6 xl:px-10'>
      <div className='flex items-start gap-2 justify-center'>
        <svg width='57' height='68' viewBox='0 0 57 68' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <ellipse cx='28.5' cy='40.9891' rx='28.5' ry='26.9969' fill='#6ADBFF' fillOpacity='0.55' />
          <g clipPath='url(#clip0_2144_1409)'>
            <path d='M33.6869 9.66001C36.7678 4.49089 44.5455 3.1315 48.3036 8.41656C50.0008 10.8033 50.1812 14.1718 48.6785 16.6968C47.8441 18.0989 46.5253 19.147 45.3408 20.2405C44.0225 21.4574 42.7586 22.7877 41.9031 24.3802C39.8913 28.1251 39.8895 32.4706 40.0517 36.6062C40.1774 39.8128 45.178 39.8289 45.0517 36.6062C44.9115 33.0322 44.6192 28.7805 46.9323 25.7662C48.1844 24.1344 49.9445 22.9482 51.3217 21.4293C52.7227 19.8842 53.7895 18.0802 54.2964 16.045C55.3106 11.9726 54.2847 7.671 51.5473 4.5019C48.9178 1.45767 44.6079 -0.304365 40.5991 0.0352563C35.9229 0.431401 31.7657 3.11657 29.3696 7.1367C27.7184 9.90709 32.0394 12.4243 33.6869 9.66001Z' fill='#01010C' />
            <path d='M44.3851 45.5305L43.8248 45.4056C43.4925 45.3014 43.1602 45.2865 42.8279 45.361C42.4951 45.376 42.1853 45.4749 41.8984 45.6576C41.607 45.8147 41.3732 46.0293 41.1969 46.3014C40.976 46.5428 40.8268 46.8262 40.7495 47.1515L40.6602 47.816C40.6616 48.2672 40.7753 48.6878 41.0015 49.0777L41.3924 49.5836C41.7043 49.8934 42.072 50.1077 42.4956 50.2264L43.0559 50.3514C43.3882 50.4555 43.7205 50.4704 44.0528 50.396C44.3855 50.3809 44.6953 50.282 44.9823 50.0994C45.2736 49.9423 45.5074 49.7277 45.6837 49.4556C45.9047 49.2141 46.0538 48.9308 46.1312 48.6055L46.2205 47.941C46.2191 47.4897 46.1053 47.0692 45.8792 46.6793L45.4883 46.1734C45.1763 45.8636 44.8086 45.6493 44.3851 45.5305Z' fill='#01010C' />
          </g>
          <defs>
            <clipPath id='clip0_2144_1409'>
              <rect width='25.6798' height='50.4491' fill='white' transform='translate(29 -0.00634766)' />
            </clipPath>
          </defs>
        </svg>
        <h2 className='text-[32px] font-bold text-[#333]'>
          Webサイトの最適化とは？
        </h2>
      </div>
      <div className='flex flex-col lg:flex-row gap-8 md:py-10 lg:items-center z-0'>
        <StaticImage
          src='../../img/pro/optimization.webp'
          className='object-cover md:w-11/12 mx-auto lg:w-1/2 2xl:w-1/3'
          alt='ウェブサイトの最適化の正解と間違い'
          loading='lazy'
        />
        <div className='relative lg:w-1/2'>
          <p className='text-xl text-left text-[#333] leading-170' style={{ position: 'relative', zIndex: 0 }}>
            ウェブサイトの最適化とは、サイトの性能を高め、お客さんが<span className='bg-blue-underline bg-no-repeat bg-[length:100%_25px] bg-[position:left_bottom_5px] inline'>知りたい情報をすぐ探せる</span>様に<span className='bg-blue-underline bg-no-repeat bg-[length:100%_25px] bg-[position:left_bottom_5px] inline'>Webサイトを改善する</span>ことです。Googleのアルゴリズムは日々変わっています。最適化がされていないWebサイトは検索順位がどんどん下がり、サイトの訪問者も減っていきます。
          </p>
        </div>
      </div>
      <div className='py-8'>
        <div className=''>
          <h3 className='text-[28px] font-bold text-center text-[#333] pt-6'>
            HPやWEBサイトを作ったまま
            <span className='relative inline-block'>
              放置
              <svg
                width={71}
                height={27}
                viewBox='0 0 71 27'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='w-[70.64px] h-[25.24px] absolute top-9 -right-2'
                preserveAspectRatio='none'
              >
                <g clipPath='url(#clip0_2144_1473)'>
                  <path
                    d='M2.41072 8.67977C19.4364 7.96621 36.4621 7.25266 53.4878 6.5391L68.188 5.92302L67.5234 1.01288C54.6122 3.26193 42.0219 7.03296 29.9248 12.0614C28.7749 12.5394 27.9337 13.4724 28.134 14.8041C28.3168 16.0193 29.3202 16.9703 30.5894 16.9716C34.0691 16.9752 37.4405 17.7841 40.5805 19.2818V14.965C38.8505 15.7861 36.9212 16.4673 35.3144 17.5097C33.4586 18.7135 32.754 21.0878 33.581 23.12C34.58 25.5751 36.8947 26.0028 39.2831 26.1513C42.4965 26.3511 42.4846 21.3509 39.2831 21.1519C38.856 21.1253 38.4171 21.0462 37.9899 21.0424C37.8541 21.0412 38.1731 21.0848 38.1631 21.1772C38.1246 21.536 38.0736 20.9034 38.203 21.2671C38.3649 21.7225 38.246 20.977 38.2105 21.4253C38.1841 21.7578 37.6748 21.8119 38.2445 21.5885C38.5033 21.487 38.7532 21.347 39.0039 21.228C40.3707 20.5793 41.7374 19.9306 43.1041 19.2818C44.7406 18.5051 44.7358 15.7433 43.1041 14.965C39.1559 13.0817 34.9813 11.9768 30.5894 11.9722L31.254 16.8823C43.351 11.8538 55.9414 8.08281 68.8526 5.83375C71.6331 5.3494 70.9812 0.806543 68.188 0.92361C51.1623 1.63715 34.1366 2.3507 17.1109 3.06425L2.41072 3.68034C-0.795098 3.8147 -0.812038 8.81483 2.41072 8.67977Z'
                    fill='#AAE9FC'
                  />
                </g>
              </svg>
            </span>
            していませんか？
          </h3>
        </div>

        <div className='flex flex-col lg:flex-row gap-6 py-8 md:py-12 lg:items-center lg:py-16'>
          <p className='text-xl text-left text-[#333] lg:w-1/2 leading-170' style={{ position: 'relative', zIndex: 0 }}>
            難しいSEO対策やサイトパフォーマンスの分析等の最適化を個人でやるのはとても大変です。
            ぜひ私達専門家にお任せください！
          </p>
          <div className='mx-auto lg:w-1/2 2xl:w-1/3'>
            <StaticImage
              src='../../img/pro/abondoned.webp'
              className='object-cover'
              alt='SEO対策のチーム'
              loading='lazy'
            />
          </div>
        </div>
      </div>
      <div>
        <p className='text-[28px] text-center text-[#333] leading-170'>
          <span className=''>今なら</span>
          <span className='text-[28px] font-bold text-center text-[#333] bg-yellow-underline bg-no-repeat bg-[length:100%_60px] bg-[position:left_bottom_5px] inline-block'>
            初期費用無料！
          </span>
          <br />
          <span className='text-[28px] font-bold text-center text-[#333] bg-yellow-underline bg-no-repeat bg-[length:100%_60px] bg-[position:left_bottom_5px] inline-block'>
            月額25,000円〜
          </span>
          <span className=''>
            Web制作・サポートを承っています！
          </span>
        </p>
      </div>
      <div className='py-8 flex justify-center lg:py-12 '>
        <CTAButton onClick={openContactModal}>無料相談する</CTAButton>
      </div>
    </section>
  )
}

export default AboutOptimization